import { Box } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import ProtectedRoute from "./components/ProtectedRoute";
import Sidebar from "./components/Sidebar";
import { AuthProvider } from "./contexts/AuthContext";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Trips from "./pages/Trips";
import Users from "./pages/Users";
import Reviews from "./pages/Reviews";

const drawerWidth = 240;

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#14b8a6", // Teal color matching rider/driver app
      dark: "#0f766e",
      light: "#5eead4",
    },
    secondary: {
      main: "#6b7280", // Gray color for secondary elements
    },
    background: {
      default: "#f9fafb", // Light gray background matching rider/driver app
      paper: "#ffffff",
    },
    text: {
      primary: "#111827", // Dark gray text
      secondary: "#6b7280", // Medium gray text
    },
    grey: {
      50: "#f9fafb",
      100: "#f3f4f6",
      200: "#e5e7eb",
      300: "#d1d5db",
      400: "#9ca3af",
      500: "#6b7280",
      600: "#4b5563",
      700: "#374151",
      800: "#1f2937",
      900: "#111827",
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff",
          border: "1px solid #e5e7eb",
          boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff",
          border: "1px solid #e5e7eb",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: "#14b8a6",
          "&:hover": {
            backgroundColor: "#0f766e",
          },
        },
        outlined: {
          borderColor: "#d1d5db",
          color: "#374151",
          "&:hover": {
            borderColor: "#14b8a6",
            backgroundColor: "#f0fdfa",
          },
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <Box sx={{ display: "flex", minHeight: '100vh', width: '100%' }}>
                    <Sidebar />
                    <Box
                      component="main"
                      sx={{
                        flexGrow: 1,
                        p: 2,
                        background: 'linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%)',
                        minHeight: '100vh',
                        width: `calc(100vw - ${drawerWidth}px)`,
                        maxWidth: `calc(100vw - ${drawerWidth}px)`,
                      }}
                    >
                      <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/users" element={<Users />} />
                        <Route path="/trips" element={<Trips />} />
                        <Route path="/reviews" element={<Reviews />} />
                      </Routes>
                    </Box>
                  </Box>
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
